module.exports = "/images/vendor/desiigner-svg/svg/ui/close.svg?a76f61391a373c700f9a3ca05cc0b604";